import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  root: {
    marginTop: '18px',
    padding: '16px',
    display: 'grid',
    gap: '10px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: '2px',
    backgroundColor: palette.shades[100],
    cursor: 'default'
  },
  counts: {
    overflowX: 'auto'
  },
  noEffect: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 10px',
    borderRadius: '2px',
    backgroundColor: palette.info.light,
    color: palette.info.dark
  }
});
export default useStyles;